import type { ChunkNotFoundDialogService } from '@app/theme/services/chunk-not-found-dialog.service';

export function handleChunkNotFound<T>(err: Error, dialogService: ChunkNotFoundDialogService): T {
    // FIXME: Currently we reload the application to the older URL. Not the new URL that user is trying to route to.
    //        So, if the user was in HOME going to GENAI-STUDIO, this will redirect back to HOME.
    if (
        err instanceof TypeError &&
        err.message.includes('Failed to fetch dynamically imported module')
    ) {
        // The platform might have been updated as the UI chunk is not found. Show a dialog instead of refreshing.
        dialogService.visible.set(true);
        return;
    }
    throw err;
}
